import { render, staticRenderFns } from "./FairPayThirdPartyPayment.vue?vue&type=template&id=43460b9e&scoped=true"
import script from "./FairPayThirdPartyPayment.vue?vue&type=script&lang=js"
export * from "./FairPayThirdPartyPayment.vue?vue&type=script&lang=js"
import style0 from "./FairPayThirdPartyPayment.vue?vue&type=style&index=0&id=43460b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43460b9e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsCustomQrCode: require('/app/components/Commons/CustomQrCode.vue').default})
